// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VvYc+","spinner":"styles_spinner__JgEnC","logo":"styles_logo__ikGEk"};